import { socialLinks } from '../constants/socialLinks';

export const newsroom = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Boldare Newsroom',
  url: 'https://www.boldare.com/newsroom/',
  description:
    'The Boldare newsroom features the latest news, media resources, and awards from the digital product development company Boldare.',
  about: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
    sameAs: Object.values(socialLinks),
  },
};
